import { FETCH_RELS_PENDING, FETCH_RELS_SUCCESS, FETCH_RELS_ERROR, ADD_REL, UPDATE_REL, REMOVE_REL, SET_ACTIVE_REL,
         } from '../ActionTypes';

// RELS REDUCER

export const Rels = (state  = { 
    pending: false,
    error: null,
    rels: [],
    active: ''
}, action) => {
switch(action.type) {
        case FETCH_RELS_PENDING: 
            return {
                ...state,
                pending: true
            }
        case FETCH_RELS_SUCCESS:
            return {
                ...state,
                pending: false,
                rels: action.payload
            }
        case FETCH_RELS_ERROR:
            return {
                ...state,
                pending: false,
                error: action.payload
            }
        case ADD_REL:
            var rel = action.payload;
            return { 
                ...state, 
                rels: state.rels.concat(rel)};
        case REMOVE_REL:
            var rid = action.payload;
            return { 
                ...state, 
                rels: state.rels.filter(({ _id }) => _id !== rid)};
        case UPDATE_REL:
            // Find the index of the rel to replace with the updated one
            var newrel = action.payload
            var newRels = state.rels
            var index = null;
            for (var i=0; i<state.rels.length; i++) {
                if ( state.rels[i]._id === newrel._id ) {
                    index = i;
                    break;
                }
            }
            newRels[index] = newrel
            return { 
                ...state, 
                pending: false,
                rels: newRels};
        case SET_ACTIVE_REL:
            var relid = action.payload;
            return {
                ...state,
                active: relid
            }
        default: 
            return state;
    }
};
